<template>
  <span v-if="organization == null">{{ DASH }}</span>
  <template v-else>
    <img
      v-if="organization.logoUrl != null"
      v-tooltip="organization.name"
      :src="organization.logoUrl"
      class="organization-owner-logo"
      :alt="organization.name" />
    <span
      v-if="showName"
      :class="{ padded: organization.logoUrl }">
      {{ organization.name }}
    </span>
  </template>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { DASH } from '@/globals';

  export interface IOrganizationLike {
    name: string;
    logoUrl?: string;
  }

  interface IProps {
    organization?: IOrganizationLike;
    logoMaxHeight?: string;
    logoMaxWidth?: string;
    showOrganizationName?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), { showOrganizationName: false });

  const showName = computed(() => props.showOrganizationName || props.organization?.logoUrl == null);
</script>

<style scoped lang="scss">
  .organization-owner-logo {
    max-height: 2rem;
  }

  .padded {
    padding-left: 0.5rem;
  }
</style>
